import { Component, ChangeDetectorRef } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams } from 'ionic-angular';
import { XpReportAddUnitPage } from "../xp-report-add-unit/xp-report-add-unit";
import { XpReportEditUnitPage } from "../xp-report-edit-unit/xp-report-edit-unit";
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { XpReportService } from "../../services/xp-report.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'page-xp-report-select-unit',
  templateUrl: 'xp-report-select-unit.html',
})
export class XpReportSelectUnitPage {

  public data: any;
  public units: any;
  public allowAddUnit = false;
  public otherGroups = [];
  public showFooter = false;
  public workorderType= 0;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public modalCtrl: ModalController,
      public changeDetector: ChangeDetectorRef,
      public superTabsCtrl: SuperTabsController,
      public reportService: XpReportService,
      public alertCtrl: AlertController,
      public translate: TranslateService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    this.workorderType = parseInt(this.data.workorder_type);
    if(!this.data.location) this.data.location = {};
    if(!this.data.location.units) this.data.location.units = [];
    for(let unit of this.data.location.units){
      if(!unit._unit_id) unit._unit_id = (unit.unit_id ? unit.unit_id : 'n' + new Date().getTime());
      if(!unit.unit_model_unit_type){
        // Tijdelijke fix i.v.m. overgang naar meerdere toesteltypen
        unit.unit_model_unit_type = 1;
      }
      // Set _selected_units als deze unit al via de search is geselecteerd
      if(unit._selected){
        this.data._selected_unit = unit; // Deprecated since 22-5-2020
        this.data._selected_units = [unit];
      }
    }
    this.units = this.data.location.units;
    this.sortUnits();
    // set allowAddUnit
    this.allowAddUnit = true;
  }

  ionViewDidEnter() {
    console.log('ReportSelectUnitPage: ionViewDidEnter');
    this.initForm();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportSelectUnitPage: ionViewDidLeave');
    if(this.data._selected_unit){
      this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportSelectUnitPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_error', 'mainTabs');
      this.data._valid.reportSelectUnitPage = -1;
    }
    this.save();
  }

  selectUnit(unit){
    for(let j = 0; j < this.units.length; j++){
      this.units[j]._selected = false;
    }
    unit._selected = true;
    this.data._selected_unit = unit; // Deprecated since 22-5-2020
    this.data._selected_units = [unit];
    this.data.checklist = null;
    if(this.data._show_all_tabs){
      this.superTabsCtrl.setColor('reportChecklistPage', 'tab_error', 'mainTabs');
      this.data._valid.reportChecklistPage = -1;
      this.data.reports = null;
      this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_error', 'mainTabs');
      this.data._valid.reportMeasurementPage = -1;
    }
    this.reportService.save();
  }

  chooseType(){
    let buttons = [];
    if(this.workorderType != 7){
      buttons.push({
        text: this.translate.instant('Algemeen'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
      buttons.push({
        text: this.translate.instant('Airco'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
    }
    buttons.push({
      text: this.translate.instant('CV'),
      handler: () => {
        this.addUnit(1);
      }
    });
    buttons.push({
      text: this.translate.instant('Grasmaaier'),
      handler: () => {
        this.addUnit(10);
      }
    });
    if(this.workorderType != 7){
      buttons.push({
        text: this.translate.instant('Gasleiding'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
    }
    buttons.push({
      text: this.translate.instant('Gas- of sfeerhaard'),
      handler: () => {
        this.addUnit(9);
      }
    });
    if(this.workorderType != 7){
      buttons.push({
        text: this.translate.instant('Ventilatie'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
      buttons.push({
        text: this.translate.instant('Waterontharder'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
      buttons.push({
        text: this.translate.instant('Hijstoestel'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
      buttons.push({
        text: this.translate.instant('CO2 melder'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
      buttons.push({
        text: this.translate.instant('Warmtepomp'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
      buttons.push({
        text: this.translate.instant('Warmtepomp boiler'),
        handler: () => {
          this.showNotAvailableAlert();
        }
      });
    }
    this.alertCtrl.create({
      title: this.translate.instant('Kies het type installatie'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  public showNotAvailableAlert(){
    this.alertCtrl.create({
      message: this.translate.instant('U heeft niet de juiste licentie voor deze optie.'),
      buttons: [this.translate.instant('OK')]
    }).present();
  }

  addUnit(unitType){
    this.modalCtrl.create(XpReportAddUnitPage, {
      unitType: unitType,
      parent: this
    }, {
      cssClass: 'modal-fullscreen'
    }).present();
  }

  editUnit(unit){
    this.modalCtrl.create(XpReportEditUnitPage, {
      unit: unit,
      parent: this
    }, {
      cssClass: 'modal-fullscreen'
    }).present();
  }

  save(){
    this.data.location.units = this.units;
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportFilesPage', 'mainTabs');
    });
  }

  sortUnits(){
    this.otherGroups = [];
    if(this.units.length === 0){
      return;
    }
    // Sort by unit_model_unit_type
    this.units.sort((a, b) => {
      if (a.unit_model_unit_type > b.unit_model_unit_type) return 1;
      if (b.unit_model_unit_type > a.unit_model_unit_type) return -1;
      return 0;
    });
    // Set group fields
    let group = '';
    let prev_group;
    let types_found = [];
    for(let unit of this.units){
      prev_group = group;
      group = '';
      let unit_model_unit_type = parseInt(unit.unit_model_unit_type);
      types_found.push(unit_model_unit_type);
      switch(unit_model_unit_type){
        case 1:
          group = 'CV\'s';
          break;
        case 2:
          group = 'Ventilatie';
          break;
        case 3:
          group = 'Waterontharders';
          break;
        case 4:
          group = 'Hijstoestellen';
          break;
        case 5:
          group = 'Airco\'s';
          break;
        case 7:
          group = 'Gasleidingen';
          break;
        case 8:
          group = 'Algemeen';
          break;
        case 9:
          group = 'Gas- of sfeerhaarden';
          break;
        case 10:
          group = 'Grasmaaiers';
          break;
        default:
          group = 'Anders';
      }
      unit._group = group;
      unit._group_same_as_prev = (group == prev_group);
    }
    // Set otherGroups
    if(types_found.indexOf(1) === -1){
      this.otherGroups.push('CV\'s');
    }
    if(types_found.indexOf(2) === -1){
      this.otherGroups.push('Ventilatie');
    }
    if(types_found.indexOf(3) === -1){
      this.otherGroups.push('Waterontharders');
    }
    if(types_found.indexOf(4) === -1){
      this.otherGroups.push('Hijstoestellen');
    }
    if(types_found.indexOf(5) === -1){
      this.otherGroups.push('Airco\'s');
    }
    if(types_found.indexOf(7) === -1){
      this.otherGroups.push('Gasleidingen');
    }
    if(types_found.indexOf(9) === -1){
      this.otherGroups.push('Gas- of sfeerhaarden');
    }
    if(types_found.indexOf(10) === -1){
      this.otherGroups.push('Grasmaaiers');
    }
    this.otherGroups.push('CO2 melders, Warmtepompen, Warmtepomp boilers');
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report-select-unit/xp-report-select-unit.ts